const CompanyRow = ({ item }) => (
    <>
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.name}</td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.industry}</td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.employees}</td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
          item.partnership === 'Gold' ? 'bg-yellow-100 text-yellow-800' :
          item.partnership === 'Silver' ? 'bg-gray-100 text-gray-800' : 'bg-orange-100 text-orange-800'
        }`}>
          {item.partnership}
        </span>
      </td>
    </>
  );
  
  export default CompanyRow;
  